module.exports = __webpack_public_path__ + "static/media/video.71123303.jpg";